module.exports = __webpack_public_path__ + "img/75617.e48e0a41.svg";